import Vue from "vue";
import App from "./calc-wrapper.vue";

Vue.config.productionTip = false;

new Vue(App).$mount("#app");
